<div class="switcher" [class.showing]="showingSwitcher">
  <h5 (click)="toggleSwitcher()">{{'GLOBAL.LAYERSWITCHER.TITLE' | translate}}</h5>
  <div class="scrollb" [style.max-height.px]="maxHeight">
    <div class="elm">
      <div class="section">
        <ng-container>
          <div class="list">
            <span class="tag tag-legend symbol" 
              [class]="item.active?'tag tag-legend symbol selected':'tag tag-legend symbol'"
              *ngFor="let item of baseLayers"
              (click)="activateByItem(item)">{{item.label}}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
